// @ts-nocheck
/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * SUREnet alerts-public API
 * OpenAPI spec version: 1
 */

export type AlertsFeaturesAlertAlertFrequentie =
  (typeof AlertsFeaturesAlertAlertFrequentie)[keyof typeof AlertsFeaturesAlertAlertFrequentie];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlertsFeaturesAlertAlertFrequentie = {
  HalfJaarlijks: 'HalfJaarlijks',
  Jaar: 'Jaar',
  TweeJaar: 'TweeJaar',
  DrieJaar: 'DrieJaar',
} as const;
